/* eslint-disable */
import React, { Component } from 'react';
import {Button, Grid, Header, Icon, Segment, Step,Dropdown, Popup} from "semantic-ui-react";
import InspectionContainer from "../../containers/inspection_container";
import ListingContainer from "../../containers/listing_container";
import Properties from ".";
import InspectionGeneralDetails from './../inspection/general_details';
import AssignClerk from './../inspection/assign_clerk';
import AdditionalDetails from './../inspection/inspection_additional_details';
import {getAddressList} from '../../data/user_api';
import { PROPERTY_API_URL } from "../../constants/api_routes";
import * as API from "../../actions/listing_action";
import moment from 'moment';
import Loader from "../universal/loader";
import ReactTable from "react-table";
import 'react-table/react-table.css'

class QuickSearch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isfetching: true,
            propertyDetails: undefined,
            propertyId: undefined,
            companyId: undefined,
            booking_requirements:undefined,
            inspectionDate: moment().format("YYYY-MM-DD"),
            step1: true,
            step2: false,
            step3: false,
            step4: false,
            step1Complete: false,
            step2Complete: false,
            step3Complete: false,
            step4Complete: false,
            userRole: undefined,
            otherReport:false
        }
    }

    setOtherReport = () => {
        this.setState({otherReport:true})
    }

    onPropertySelected = (propertyId, data) => {
        this.setState({
            propertyDetails: data,
            propertyId: propertyId,
            companyId: data['company_id'],
            booking_requirements:data["booking_requirements"],
            step1: false,
            step2: true,
            step1Complete: true
        });
    };
    onComplete = (inspectionDate,startTime,endTime) => {
        this.setState({inspectionDate: inspectionDate,startTime:startTime,endTime:endTime});
        if (this.state.userRole === "admin") {
            this.setState({step3: true, step2: false, step2Complete: true});
        }
        else {
            this.setState({step4: true, step2: false,step2Complete: true, step3Complete: true});
        }
    };
    onAdditionalStepComplete = () => {
        this.setState({step3: false, step4: true, step3Complete: true});
    };
    getPropertyAddressList = async () => {
        this.setState({isFetching: true,selectedAddressId:null,addresses:null})
        const addressList = await getAddressList(PROPERTY_API_URL);
        this.setState({addresses: addressList, isFetching:false});
    };

    componentWillMount() {
        const userRole = JSON.parse(localStorage.getItem('user'))['role'];
        this.setState({ userRole });
        this.getPropertyAddressList().then(() => {
        this.setState({isFetching: false})
    });
    }


    render() {
        const columns = [ {
            Header: 'Address Groups',
            accessor: 'address',
            className:'caddress-width',
            headerClassName:'caddress-width',
            filterable: true
        },{
            Header: 'Action',
            id: 'edit',
            accessor: 'id',
            sortable:false,
            Cell: ({value}) => (
                <div className="center-aligned">
                    <Button basic compact icon positive size='mini' onClick={(e) => { this.props.getQuickSearchList(PROPERTY_API_URL, value); this.setState({ selectedAddressId: value }) }}><Icon
                        name='eye'/>View Properties</Button>
                </div>
            )
            }];
        
        return (<div>
            <div className="inspection-create-propertylist-table">
                <div className="pad-top" style={{paddingBottom:0}}>
                    <Header content="Quick Property Search / Quick Inspection Create " size='large' textAlign='left'/>
                </div>
                <div style={{margin: "1% 0% 0% 0%"}}>
                    <Step.Group ordered widths={4} size='mini'>
                        <Step completed={this.state.step1Complete} active={this.state.step1} onClick={()=>{this.state.step2?this.setState({step2:false,step1:true,step1Complete:false}):null}}>
                            <Step.Content>
                                <Step.Title>Property Selection</Step.Title>
                            </Step.Content>
                        </Step>

                        <Step completed={this.state.step2Complete} active={this.state.step2}>
                            <Step.Content>
                                <Step.Title>General Details</Step.Title>
                            </Step.Content>
                        </Step>

                        {this.state.userRole === "admin" &&
                        <Step active={this.state.step3} completed={this.state.step3Complete}>
                            <Step.Content>
                                <Step.Title>Assign Clerk</Step.Title>
                            </Step.Content>
                        </Step>}

                        <Step active={this.state.step4}>
                            <Step.Content>
                                <Step.Title>Notes & Attachments</Step.Title>
                            </Step.Content>
                        </Step>
                    </Step.Group>
                </div>
                {this.state.propertyDetails && <Segment raised>
                    <Header as='h4'>
                        <span>{"Property Address: "+this.state.propertyDetails['full_address']}</span><br/>
                        <span>{"Company Name: "+this.state.propertyDetails['company_name']}</span>
                    </Header>
                    </Segment>}
                <Segment raised>
                    {this.state.addresses && <Header>{this.state.addresses.length} Addresses Found</Header>}
                    <Grid style={{marginTop: '0px'}} stackable>
                        <Grid.Row style={{paddingTop:'0'}}>
                            {this.state.step1 && <div className="nested-listing-container pad-bottom">
                                {this.state.addresses ? 
                                    <ReactTable
                        data={this.state.addresses}
                        columns={columns}
                        defaultFilterMethod={(filter, row) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] !== undefined ? String(row[id]).replace(/[^\w]/g,'').toUpperCase().indexOf(filter.value.replace(/[^\w]/g,'').toUpperCase()) >= 0 : true
                        }}
                        defaultPageSize={100}
                        minRows={12}
                        style={{
                            height:'290px'
                        }}
                        noDataText="No properties found"
                        pageSizeOptions={[5, 10, 20, 25, 50, 100,200,500]}
                    /> : <Loader contain={true} />}
                                {this.state.selectedAddressId && this.props.isFetching && !this.state.isFetching && <Loader contain={true} />}
                                 <Properties selectProperty="yes" noLoad={true} onPropertySelected={this.onPropertySelected} getPropertyAddressList={this.getPropertyAddressList} userRole={this.state.userRole} />
                            </div>}
                            {this.state.step2 &&
                            <InspectionGeneralDetails setOtherReport={this.setOtherReport}userRole={this.state.userRole} propertyId={this.state.propertyId} propertyDetails={this.state.propertyDetails} onComplete={this.onComplete}
                                                      companyId={this.state.companyId} booking_requirements={ this.state.booking_requirements }/>
                            }
                            {this.state.step3 && <div
                                className="nested-listing-container pad-all">
                                <div className="right-aligned"><Button primary onClick={() => {
                                    this.setState({step3: false, step4: true, step3Complete: true})
                                }}>Go Next <Icon name="right arrow"/></Button></div>
                                <AssignClerk companyId={this.state.companyId} date={this.state.inspectionDate} startTime={this.state.startTime} endTime={this.state.endTime} />
                            </div>}
                            {this.state.step4 &&
                            <AdditionalDetails otherReport={this.state.otherReport}onAdditonalStepComplete={this.onAdditionalStepComplete}/>}
                        </Grid.Row>
                    </Grid>
                </Segment>

            </div>
        </div>);
    }

}

export default InspectionContainer(ListingContainer(QuickSearch));


// WEBPACK FOOTER //
// ./src/views/properties/quicksearch.js